import { useQuery, gql, type QueryResult } from '@apollo/react-hooks';
import { getLocation } from '#/graphql/queries';
import type { GetLocationQuery } from '#/graphql/types';

export const GET_LOCATION = gql(getLocation);

const useLocationQuery = (id?: string) => {
  const query: QueryResult<GetLocationQuery> = useQuery(GET_LOCATION, {
    variables: { id },
    fetchPolicy: 'cache-and-network',
  });

  return query;
};

export default useLocationQuery;
